import type { TicketPriority } from '@/types/ticket'
import { priorityLabels } from '@/lib/status'
import { railSelectClass } from './railSelect'

export function PrioritySelect({ value, onChange, disabled }: { value: TicketPriority; onChange: (p: TicketPriority) => void; disabled?: boolean }) {
  return (
    <select disabled={disabled} value={value} onChange={e => onChange(e.target.value as TicketPriority)} className={railSelectClass}>
      {(['low', 'normal', 'high'] as TicketPriority[]).map(p => <option key={p} value={p}>{priorityLabels[p]}</option>)}
    </select>
  )
}
